/* eslint-disable @typescript-eslint/naming-convention */
import { Button, Flex, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { COLLARTYPEKEY, FALLBACKIMAGES, Paths, breadCrumbFirstLevel, breadCrumbProductsSecondLevel } from "../common/commonConstants"
import { SimpleGridWrapper, SubPage, SubPageContent } from "../components/SubPage"
import { BannerType1 } from "../components/commons/bannerType1"
import { BreadCrumb } from "../components/commons/breadcrumb"
import { ProductThumbnailType3 } from "../components/commons/productThumbnailType3"
import { SealantBannerHeroImg, SealantTileHeroImg } from "../components/images"
import { Colors } from "../theme/colors"
import { useAllCollarsQuery, type AllCollarsQuery, type Product4Menu } from "../type-and-hooks"

type AssociativeArray = Record<string, Product4Menu[]>

const getSubCategoryTileImage = (subCategory: string): string | undefined => (/acrylic/i.test(subCategory) ? SealantTileHeroImg : undefined)

export const AllSealants = (): JSX.Element => {
  const { data } = useAllCollarsQuery({ variables: { collarTypeId: COLLARTYPEKEY.SEALANT }, fetchPolicy: "cache-and-network" })

  const navigate = useNavigate()
  const fallBackImage = FALLBACKIMAGES["150x150"]

  const [allSealantsCategory, setAllSealantsCategory] = useState<AssociativeArray>({})

  const getSubCategoryData = (data: AllCollarsQuery): AssociativeArray => {
    const acc: AssociativeArray = {}
    data?.allCollars?.map(item => {
      const subCategory = item?.subcategory ?? "unknown"
      if (item) {
        acc[subCategory] = [...(acc[subCategory] ?? []), item]
      }
      return acc
    })

    return acc
  }

  useEffect(() => {
    if (data) {
      setAllSealantsCategory(getSubCategoryData(data))
    }
  }, [data])

  const handleClick = (item: string | undefined | null): void => {
    if (item) {
      void navigate(item ?? "/sealant", { state: { pid: item } })
    } else {
      console.error("Product is not available", item)
    }
  }

  return (
    <SubPage>
      <BannerType1
        heading="All Sealants"
        image={SealantBannerHeroImg}
        subText2Styles={{ marginTop: "59px" }}
        imageStyles={{ width: "380px", height: "330px" }}
      />
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbProductsSecondLevel,
          thirdLevel: { title: "Sealant" }
        }}
      />
      <Flex
        align={"center"}
        justify="center"
        flexDir={"column"}
        maxW={["328px", "328px", "328px", "580px", "580px", "580px"]}
        px={[0, 0, 0, 4, 4, 4]}
        margin={"auto"}
        mt="30px"
      >
        <Text align={"center"} textAlign={["left", "left", "left", "center", "center", "center"]}>
          Snap Fire Rated Sealants perform an integral part of the installation requirements when using Snap collars - check out our compliance
          reports for where and how to use our Sealants.
        </Text>
        <Text variant="Body1Bold" color={Colors.Secondary.c2} my="23px" textAlign={["left", "left", "left", "center", "center", "center"]}>
          Select a sealant from below for further information.
        </Text>
        <Button
          onClick={() => {
            navigate(Paths.DISTRIBUTORS)
          }}
          variant={"Button1Regular"}
        >
          Buy From Distributor
        </Button>
      </Flex>
      <SubPageContent>
        <Flex overflow={"hidden"} mb="137px" justify={"center"}>
          <SimpleGridWrapper
            props={{
              columns: [1, 1, 1, 3, 3, 3],
              spacing: ["16px", "16px", "16px", "32px", "32px", "32px"],
              justifyContent: "center",
              padding: "32px 16px",
              alignContent: "center",
              alignItems: "center",
              spacingY: ["40px", "40px", "40px", "20px", "20px", "20px"]
            }}
          >
            {allSealantsCategory &&
              Object.entries(allSealantsCategory).map(([key, sealants]) => (
                <ProductThumbnailType3
                  key={key}
                  heading={key}
                  subText={`${sealants.length ?? 0} items`}
                  bg={getSubCategoryTileImage(key)}
                  onClickCallBack={() => {
                    handleClick(key.toLowerCase().replaceAll(" / ", "-").replaceAll(" - ", "-").replaceAll(" ", "-"))
                  }}
                />
              ))}
          </SimpleGridWrapper>
        </Flex>
      </SubPageContent>
    </SubPage>
  )
}